<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	import "@/assets/css/animate/animate.min.css";
	export default {
		name: 'app',
		components: {}
	}
</script>

<style>
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
		font-size: .83333vw;
		color: #333;
		font-family: Arial;
	}
	.animated.an1 {
		animation-delay: .1s
	}
	
	.animated.an2 {
		animation-delay: .2s
	}
	
	.animated.an3 {
		animation-delay: .3s
	}
	
	.animated.an4 {
		animation-delay: .4s
	}
	
	.animated.an5 {
		animation-delay: .5s
	}
</style>